import React from 'react';
import PropTypes from 'prop-types';

const DiscoverCasinoTile = ({ preferredLocation, openBookingPage }) => (
  <div className="discover-casino">
    <div className="home-hero" />
    <div className="right-column">
      <div className="location-text">Wind Creek {preferredLocation}</div>
      <div className="winning-moment-title">Find Your Winning Moment</div>
      <div className="winning-moment-body">
        Sed ut perspiciatis unde omnis iste natus error sit voluptatem. Sed ut
        perspiciatis unde omnis iste natus.
      </div>
      <button
        className="book-stay-button"
        type="button"
        onClick={openBookingPage}
      >
        Book a Stay
      </button>
    </div>
  </div>
);

DiscoverCasinoTile.propTypes = {
  preferredLocation: PropTypes.string,
  openBookingPage: PropTypes.func
};

export default DiscoverCasinoTile;
